import { Link } from 'react-router-dom';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import { HOME_TDK } from '@/data/site';
import {
  MOVIES,
  SPECIALS,
  getFeaturedMovies,
  getLatestMovies,
  getPopularSeries,
} from '@/data/catalog';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntries from '@/pages/home/components/CategoryEntries';
import MovieScrollRow from '@/pages/home/components/MovieScrollRow';
import RatingRanking from '@/pages/home/components/RatingRanking';
import SpecialShowcase from '@/pages/home/components/SpecialShowcase';
import SiteIntro from '@/pages/home/components/SiteIntro';
import SectionHeading from '@/components/feature/SectionHeading';

export default function Home() {
  useDocumentMeta(HOME_TDK);

  const featured = getFeaturedMovies();
  const latestMovies = getLatestMovies(14);
  const popularSeries = getPopularSeries(14);
  const topRated = [...MOVIES].sort((a, b) => b.rating - a.rating).slice(0, 5);

  return (
    <>
      <HeroCarousel movies={featured} />
      <CategoryEntries />

      <section className="mx-auto mt-12 w-full max-w-[1440px] px-4 md:mt-16 md:px-8">
        <SectionHeading
          title="最新电影推荐"
          enTitle="New in Theaters"
          description="刚刚上线的新片与近期话题之作，按上线时间整理"
          morePath="/category/latest"
          moreLabel="查看全部最新"
        />
        <MovieScrollRow movies={latestMovies} />
      </section>

      <section className="mx-auto mt-12 w-full max-w-[1440px] px-4 md:mt-16 md:px-8">
        <SectionHeading
          title="热门电视剧推荐"
          enTitle="Trending Series"
          description="正在追更与口碑发酵中的剧集，一次看够"
          morePath="/category/tv"
          moreLabel="进入电视剧频道"
        />
        <MovieScrollRow movies={popularSeries} morePath="/category/tv" />
      </section>

      <RatingRanking movies={topRated} />

      <section className="mx-auto mt-16 w-full max-w-[1440px] px-4 md:mt-20 md:px-8">
        <SectionHeading
          title="主题影视专题"
          enTitle="Curated Collections"
          description="按类型与情绪整理的片单，解决“今晚看什么”的老问题"
          morePath="/special/special-01"
          moreLabel="浏览全部专题"
        />
        <SpecialShowcase topics={SPECIALS} />
      </section>

      <SiteIntro />

      <section className="mx-auto mt-14 w-full max-w-[1440px] px-4 md:mt-16 md:px-8">
        <div className="flex flex-col items-start justify-between gap-5 rounded-lg bg-primary-950 px-6 py-9 md:flex-row md:items-center md:px-10">
          <div>
            <h2 className="text-xl font-bold text-background-50 md:text-2xl">没想好从哪一部开始？</h2>
            <p className="mt-2 text-sm text-background-300/80">
              输入片名、演员或类型，大雷影视帮你在 {MOVIES.length} 部演示作品里快速定位。
            </p>
          </div>
          <Link
            to="/search"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            <i className="ri-search-line" />
            开始搜索
          </Link>
        </div>
      </section>
    </>
  );
}